// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"play-circle"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M18.25 12L8.5 17.6292L8.5 6.37085L18.25 12Z"}}]}]};

const PlayCircleIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'play-circle',
    ref,
    icon: element,
  },
));

PlayCircleIcon.displayName = 'PlayCircleIcon';

export default PlayCircleIcon;
